import React, { Component } from 'react';
import Pagniator from 'react-paginate';

require('./index.scss');

const BREAK_ARIA_LABELS = { forward: 'More pages', backward: 'More pages' };

export default class Pagination extends Component {
  constructor(props) {
    super(props);
    this.onChangePageSizeTimer = null;
    this.containerRef = React.createRef();
  }

  componentDidMount() {
    this.removeNavigationRoleFromPageList();
  }

  componentDidUpdate(prevProps) {
    this.removeNavigationRoleFromPageList();
    if (prevProps.pageSize !== this.props.pageSize) {
      this.searchForChangePageSize();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.onChangePageSizeTimer);
  }

  // react-paginate 8 forces role="navigation" onto its <ul>, which makes every <li> an invalid listitem.
  removeNavigationRoleFromPageList() {
    const pageList = this.containerRef.current?.querySelector('ul');
    pageList?.removeAttribute('role');
  }

  totalPage(totalCount, pageSize) {
    return Math.ceil(totalCount / pageSize);
  }

  handlePageClick(page) {
    const { onPageClick } = this.props;
    onPageClick(page + 1);
  }

  searchForChangePageSize() {
    if (this.onChangePageSizeTimer) {
      clearTimeout(this.onChangePageSizeTimer);
    }
    this.onChangePageSizeTimer = setTimeout(() => {
      this.handlePageClick(0);
    }, 1000);
  }

  onChangePageSize(pageSize) {
    const { onChangePageSize } = this.props;
    if (pageSize && pageSize !== '0') {
      onChangePageSize(parseInt(pageSize, 10));
    }
  }

  render() {
    const { currentPage, totalCount, pageSize } = this.props;
    return (
      <div className='pagination-container' ref={this.containerRef}>
        <Pagniator
          activeClassName='page-active'
          ariaLabelBuilder={(page) => `Page ${page}`}
          breakAriaLabels={BREAK_ARIA_LABELS}
          breakLabel={<span aria-hidden='true'>&hellip;</span>}
          forcePage={parseInt(currentPage, 10) - 1}
          marginPagesDisplayed={1}
          nextLabel={<span aria-hidden='true'>&gt;</span>}
          nextLinkClassName='btn'
          pageCount={this.totalPage(totalCount, pageSize)}
          pageLinkClassName='btn'
          pageRangeDisplayed={4}
          previousLabel={<span aria-hidden='true'>&lt;</span>}
          previousLinkClassName='btn'
          onPageChange={(page) => this.handlePageClick(page.selected)}
        />
        <div className='input-container'>
          <input
            aria-label='Page size'
            className='form-control'
            min='1'
            style={{ width: '50px' }}
            type='number'
            value={pageSize}
            onChange={(e) => this.onChangePageSize(e.target.value)}
          />
          <span>Per Page</span>
        </div>
      </div>
    );
  }
}
